<template>
  <div class="hs-gradient-button" :style="{width: width, height: height, fontSize: fontSize}">
    <slot>
      <div :class="type" @click.stop="$emit('click')" v-html="currentTitle"></div>
    </slot>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '50px'
    },
    fontSize: {
      type: String,
      default: '1rem'
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  created() {
    this._initTitle()
  },
  data() {
    return {
      currentTitle: ''
    }
  },
  watch: {
    title() {
      this._initTitle()
    }
  },
  methods: {
    _initTitle() {
      if (this.language === 'CN') {
        this.currentTitle = Array.from(this.title).join('&nbsp;')
      } else {
        this.currentTitle = this.title
      }
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-gradient-button
  @extend .flex-center
  >div
    @extend .flex-center
    width 100%
    height 100%
    border-radius 4px
    background $color_red_gradient_1
    color $color_white
    font-size 1.1em
  >.default
    width calc(100% - 80px)
  >.common
    width auto
    height 38px
    padding 0 15px
  >.full
    width 100%
  >.full-square
    border-radius 4px
    background $color_background_liner_theme
    font-size 1rem
  >.disabled-full
    @extend .disabled
    background $color_gray_background_1
    color $color_white
  >.disabled
    @extend .disabled
    background $color_gray_background_0
    color $color_gray_text
  >.gray-yellow
    background $color_background_liner_theme_9
</style>
